export default __webpack_public_path__ + "static/media/bwGroup1409.afd29d21.svg";